import storeCart from '@/storeCart'

export default {
  data () {
    return {}
  },
  computed: {
    paymentRunning: {
      get () {
        if (!storeCart.state.initialized) {
          storeCart.commit('readFromLocalStorage')
        }
        if (storeCart.state.paymentRunning !== null) {
          console.log('paymentRunning is', storeCart.state.paymentRunning)
        }
        return storeCart.state.paymentRunning
      },
      set (value) {
        if (value !== null) {
          localStorage.setItem('payment_running', JSON.stringify(value))
          console.warn('set payment_running')
        } else {
          localStorage.removeItem('payment_running')
          console.warn('removed payment_running')
        }
        storeCart.commit({ type: 'setPaymentRunning', value })
      }
    },
    dwUserValidatedTicketsTemp () {
      return storeCart.state.userValidatedTicketsTemp
    },
    dwMyTickets () {
      if (!storeCart.state.initialized) {
        storeCart.commit('readFromLocalStorage')
      }
      return storeCart.state.myTickets.map(el => {
        let newEl = JSON.parse(JSON.stringify(el))
        /* if (newEl.origin) {
          newEl.subtitle = this.dictValue('TripResume', null, { from: newEl.origin, to: newEl.destination })
          if (newEl.through) {
            newEl.subtitle += ' ' + this.dictValue('TripResume2', null, { through: newEl.through })
          }
        } */
        return newEl
      })
    },
    dwMyTicketsKey () {
      return this.dwMyTickets.map(tag => tag.id).join('_')
    } /* ,
    dwMyticketsString () {
      return JSON.stringify(this.dwMyTickets)
    } */
  },
  methods: {
    dwReplaceUserTickets (tickets) {
      storeCart.commit({ type: 'replaceUserTickets', tickets })
    },
    dwSaveNewTicket (ticket) {
      storeCart.commit({ type: 'saveNewTicket', ticket: { ...ticket } })
    },
    dwSetTicketUserValidated (id, validated) {
      console.log(`dwSetTicketUserValidated ('${id}', ${validated})`)
      storeCart.commit({ type: 'setMyTicketUserValidated', id, validated })
    },
    dwSetTicketVadValidated (id, validated) {
      console.log(`dwSetTicketVadValidated ('${id}', ${validated})`)
      storeCart.commit({ type: 'setMyTicketVadValidated', id, validated })
    },
    dwUpdateTicketData (id, data) {
      console.log(`dwUpdateTicketData ('${id}', ${data})`)
      storeCart.commit({ type: 'updateTicketData', id, data })
    },
    dwDeleteTicket (id) {
      storeCart.commit({ type: 'deleteTicket', id })
    },
    dwAddPendingUserValidation (id, value) {
      storeCart.commit({ type: 'addPendingUserValidation', id, value })
    },
    dwRemovePendingUserValidation (id) {
      storeCart.commit({ type: 'removePendingUserValidation', id })
    }
  },
  mounted () {},
  watch: {
    dwMyTicketsKey (newV, oldV) {
      if (newV !== oldV) {
        localStorage.setItem('myTickets', JSON.stringify(this.dwMyTickets))
      }
    },
    /* dwMyticketsString (newV, oldV) {
      console.log('dwMyticketsString changed', newV !== oldV)
      if (newV !== oldV) {
        localStorage.setItem('myTickets', newV)
      }
    }, */
    dwUserValidatedTicketsTemp (newV) {
      console.log('userValidatedTicketsTemp listener', newV)
      localStorage.setItem('userValidatedTicketsTemp', JSON.stringify(this.dwUserValidatedTicketsTemp))
    }
  }
}
